import { useAtomValue } from 'jotai';
import {
  Controller,
  SubmitHandler,
  useForm,
} from 'react-hook-form';

import { phoneNumberRules, phoneNumberValidationMessage } from '@consumer-frontend/nc-utils';
import { Container, Fieldset } from '@consumer-frontend/shared-ui';

import { NcPhoneNumberDisclaimer } from './NcPhoneNumberDisclaimer';
import { useApplyRouting } from '../../routing';
import { registrationDataAtom } from '../../store';
import { NcButton } from '../NcButton';
import { NcForm } from '../NcForm';
import { NcPhoneInput } from '../NcPhoneInput';
import { NcProgressBar } from '../NcProgressBar';

import '@consumer-bootstrap/brands/netcredit/apply/phone-number.scss';

type PhoneNumberT = {
  phoneNumber: string;
};

export const phoneNumberValidations = phoneNumberRules(phoneNumberValidationMessage);

export const NcPhoneNumberPage = () => {
  const registrationData = useAtomValue(registrationDataAtom);

  const { handleContinue, progress } = useApplyRouting();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<PhoneNumberT>({
    defaultValues: { phoneNumber: registrationData.phoneNumber ?? '' },
    mode: 'onSubmit',
    reValidateMode: 'onChange',
  });

  const onSubmit: SubmitHandler<PhoneNumberT> = async (data) => {
    await handleContinue({ phoneNumber: data.phoneNumber });
  };

  return (
    <Container className="nc-phone-number-page" hasBoxShadow>
      <NcProgressBar progress={progress} />

      <h1 className="h3">Phone Number</h1>

      <NcForm onSubmit={handleSubmit(onSubmit)}>
        <Controller
          control={control}
          name="phoneNumber"
          rules={phoneNumberValidations}
          render={({ field }) => (
            <NcPhoneInput
              {...field}
              autoComplete="tel-national"
              errorMessage={errors.phoneNumber?.message}
              id="phoneNumber"
              label={<span className="form-label">Phone Number</span>}
            />
          )}
        />

        <Fieldset className="cta-buttons">
          <NcButton type="submit">Continue</NcButton>
        </Fieldset>

        <NcPhoneNumberDisclaimer />
      </NcForm>
    </Container>
  );
};
